export const FETCH_COMPOUNDS_REQUEST = 'compounds/FETCH_COMPOUNDS_REQUEST'
export const FETCH_COMPOUNDS_SUCCESS = 'compounds/FETCH_COMPOUNDS_SUCCESS'
export const FETCH_COMPOUNDS_FAILURE = 'compounds/FETCH_COMPOUNDS_FAILURE'

export const FETCH_COMPOUND_REQUEST = 'compounds/FETCH_COMPOUND_REQUEST'
export const FETCH_COMPOUND_SUCCESS = 'compounds/FETCH_COMPOUND_SUCCESS'
export const FETCH_COMPOUND_FAILURE = 'compounds/FETCH_COMPOUND_FAILURE'

export const UPDATE_COMPOUND_REQUEST = 'compounds/UPDATE_COMPOUND_REQUEST'
export const UPDATE_COMPOUND_SUCCESS = 'compounds/UPDATE_COMPOUND_SUCCESS'
export const UPDATE_COMPOUND_FAILURE = 'compounds/UPDATE_COMPOUND_FAILURE'

export const CREATE_COMPOUND_REQUEST = 'compounds/CREATE_COMPOUND_REQUEST'
export const CREATE_COMPOUND_SUCCESS = 'compounds/CREATE_COMPOUND_SUCCESS'
export const CREATE_COMPOUND_FAILURE = 'compounds/CREATE_COMPOUND_FAILURE'

export const FETCH_COMPOUND_PAYMENTS_REQUEST =
  'compounds/FETCH_COMPOUND_PAYMENTS_REQUEST'
export const FETCH_COMPOUND_PAYMENTS_SUCCESS =
  'compounds/FETCH_COMPOUND_PAYMENTS_SUCCESS'
export const FETCH_COMPOUND_PAYMENTS_FAILURE =
  'compounds/FETCH_COMPOUND_PAYMENTS_FAILURE'

export const CREATE_COMPOUND_PAYMENT_REQUEST =
  'compounds/CREATE_COMPOUND_PAYMENT_REQUEST'
export const CREATE_COMPOUND_PAYMENT_SUCCESS =
  'compounds/CREATE_COMPOUND_PAYMENT_SUCCESS'
export const CREATE_COMPOUND_PAYMENT_FAILURE =
  'compounds/CREATE_COMPOUND_PAYMENT_FAILURE'

export const UPDATE_COMPOUND_PAYMENT_REQUEST =
  'compounds/UPDATE_COMPOUND_PAYMENT_REQUEST'
export const UPDATE_COMPOUND_PAYMENT_SUCCESS =
  'compounds/UPDATE_COMPOUND_PAYMENT_SUCCESS'
export const UPDATE_COMPOUND_PAYMENT_FAILURE =
  'compounds/UPDATE_COMPOUND_PAYMENT_FAILURE'

export const DELETE_COMPOUND_PAYMENT_REQUEST =
  'compounds/DELETE_COMPOUND_PAYMENT_REQUEST'
export const DELETE_COMPOUND_PAYMENT_SUCCESS =
  'compounds/DELETE_COMPOUND_PAYMENT_SUCCESS'
export const DELETE_COMPOUND_PAYMENT_FAILURE =
  'compounds/DELETE_COMPOUND_PAYMENT_FAILURE'

export const DOWNLOAD_COMPOUND_PAYMENT_REQUEST =
  'compounds/DOWNLOAD_COMPOUND_PAYMENT_REQUEST'
export const DOWNLOAD_COMPOUND_PAYMENT_SUCCESS =
  'compounds/DOWNLOAD_COMPOUND_PAYMENT_SUCCESS'
export const DOWNLOAD_COMPOUND_PAYMENT_FAILURE =
  'compounds/DOWNLOAD_COMPOUND_PAYMENT_FAILURE'

export const FETCH_COMPOUND_DOCUMENTS_REQUEST =
  'compounds/FETCH_COMPOUND_DOCUMENTS_REQUEST'
export const FETCH_COMPOUND_DOCUMENTS_SUCCESS =
  'compounds/FETCH_COMPOUND_DOCUMENTS_SUCCESS'
export const FETCH_COMPOUND_DOCUMENTS_FAILURE =
  'compounds/FETCH_COMPOUND_DOCUMENTS_FAILURE'

export const DOWNLOAD_COMPOUND_DOCUMENT_REQUEST =
  'compounds/DOWNLOAD_COMPOUND_DOCUMENT_REQUEST'
export const DOWNLOAD_COMPOUND_DOCUMENT_SUCCESS =
  'compounds/DOWNLOAD_COMPOUND_DOCUMENT_SUCCESS'
export const DOWNLOAD_COMPOUND_DOCUMENT_FAILURE =
  'compounds/DOWNLOAD_COMPOUND_DOCUMENT_FAILURE'

export const GENERATE_COMPOUND_DOCUMENT_REQUEST =
  'compounds/GENERATE_COMPOUND_DOCUMENT_REQUEST'
export const GENERATE_COMPOUND_DOCUMENT_SUCCESS =
  'compounds/GENERATE_COMPOUND_DOCUMENT_SUCCESS'
export const GENERATE_COMPOUND_DOCUMENT_FAILURE =
  'compounds/GENERATE_COMPOUND_DOCUMENT_FAILURE'

export const DELETE_COMPOUND_DOCUMENT_REQUEST =
  'compounds/DELETE_COMPOUND_DOCUMENT_REQUEST'
export const DELETE_COMPOUND_DOCUMENT_SUCCESS =
  'compounds/DELETE_COMPOUND_DOCUMENT_SUCCESS'
export const DELETE_COMPOUND_DOCUMENT_FAILURE =
  'compounds/DELETE_COMPOUND_DOCUMENT_FAILURE'

export const UPDATE_FIELD = 'compounds/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'compounds/SET_DEFAULT_DATA'
